import { CzechSuklRsAtcGroupResponse } from 'com.cogvio.pricemonitor.api';

type ProductVersion = CzechSuklRsAtcGroupResponse['products'][number]['productVersions'][number];

export function formatVersionDncDou(version: ProductVersion): string {
	return [version.dnc1, version.puhr].filter(Boolean).join(' / ') || '–';
}

export type UnifiedDncDou = {
	display: string;
	isUniform: boolean;
};

/**
 * Resolves a single DNC/DoÚ value for a product version group.
 * When values differ between versions, all distinct values are shown.
 *
 * @param {ProductVersion[]} versions the versions to format.
 * @returns {string} the formatted DNC/DoÚ display value.
 */
export function formatProductDncDou(versions: ProductVersion[]): string {
	const formatted = versions.map(formatVersionDncDou);
	const distinct = Array.from(new Set(formatted));

	if (distinct.length <= 1) {
		return distinct[0] ?? '–';
	}

	return distinct.join(', ');
}

export function resolveUnifiedDncDou(versions: ProductVersion[]): UnifiedDncDou {
	const formatted = versions.map(formatVersionDncDou);
	const distinct = Array.from(new Set(formatted));

	return {
		display: formatProductDncDou(versions),
		isUniform: distinct.length <= 1,
	};
}
